import createStaticEntity from '../createStaticEntity';
import { StaticOrganicCarbonLevelT } from './staticOrganicCarbonLevel.types';

export default createStaticEntity<StaticOrganicCarbonLevelT>()({
    entityName: 'staticOrganicCarbonLevel',
    url: () => `/v3/static/organiccarbonlevels`,
});
